var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"py-5 px-2"},[_c('return-materials',{staticClass:"mx-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }